// Libraries
import { Icon, IconProps } from '@chakra-ui/react';

/**
 * Component that renders the RoundedArrow icon.
 * @param {IconProps} props - The IconProps for the RoundedArrowIcon component.
 * @returns {ReactElement} The RoundedArrowIcon component.
 */
export const RoundedArrowIcon = (props: IconProps) => {
  const { color = '#25CAD2', ...rest } = props;
  return (
    <Icon viewBox='0 0 14 8' color={color} {...rest} id='graph'>
      <path
        d='M9.45932 2.7486L1.20312 2.7486C1.02192 2.7486 0.875 2.9165 0.875 3.1236L0.875 4.8736C0.875 5.08069 1.02192 5.2486 1.20312 5.2486L9.45932 5.2486L9.45932 6.68794C9.45932 7.35613 10.1662 7.69075 10.5796 7.21828L12.9328 4.52894C13.1891 4.23603 13.1891 3.76116 12.9328 3.46828L10.5796 0.778939C10.1662 0.30647 9.45932 0.641096 9.45932 1.30928L9.45932 2.7486Z'
        fill='currentColor'
      />
    </Icon>
  );
};
